var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/warning-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "warning-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9 10.3125C8.6925 10.3125 8.4375 10.0575 8.4375 9.75V5.8125C8.4375 5.505 8.6925 5.25 9 5.25C9.3075 5.25 9.5625 5.505 9.5625 5.8125V9.75C9.5625 10.0575 9.3075 10.3125 9 10.3125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9 12.9379C8.7975 12.9379 8.60998 12.8629 8.46748 12.7204C8.39998 12.6454 8.34751 12.5629 8.30251 12.4729C8.26501 12.3829 8.25 12.2854 8.25 12.1879C8.25 11.9929 8.33248 11.7979 8.46748 11.6554C8.74498 11.3779 9.25502 11.3779 9.53252 11.6554C9.66752 11.7979 9.75 11.9929 9.75 12.1879C9.75 12.2854 9.72749 12.3829 9.68999 12.4729C9.65249 12.5629 9.60002 12.6454 9.53252 12.7204C9.39002 12.8629 9.2025 12.9379 9 12.9379Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.00111 17.0623C8.49861 17.0623 7.9886 16.9348 7.5386 16.6723L3.0836 14.0998C2.1836 13.5748 1.62109 12.6073 1.62109 11.5648V6.43484C1.62109 5.39234 2.1836 4.42484 3.0836 3.89984L7.5386 1.32734C8.4386 0.802344 9.55612 0.802344 10.4636 1.32734L14.9186 3.89984C15.8186 4.42484 16.3811 5.39234 16.3811 6.43484V11.5648C16.3811 12.6073 15.8186 13.5748 14.9186 14.0998L10.4636 16.6723C10.0136 16.9348 9.50361 17.0623 9.00111 17.0623ZM9.00111 2.06233C8.69361 2.06233 8.3786 2.14483 8.1011 2.30233L3.6461 4.87483C3.0911 5.19733 2.74609 5.78984 2.74609 6.43484V11.5648C2.74609 12.2023 3.0911 12.8023 3.6461 13.1248L8.1011 15.6973C8.6561 16.0198 9.34612 16.0198 9.89362 15.6973L14.3486 13.1248C14.9036 12.8023 15.2486 12.2098 15.2486 11.5648V6.43484C15.2486 5.79734 14.9036 5.19733 14.3486 4.87483L9.89362 2.30233C9.62362 2.14483 9.30861 2.06233 9.00111 2.06233Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.85f8ab6d2adb5462f6d2afb06f6496a3.svg";
export { ForwardRef as ReactComponent };